import * as React from 'react';
import { Button as ButtonUi } from '@cian/ui-kit';
import { IButtonProps } from '@cian/ui-kit/button/types';
import cn from 'clsx';

import * as styles from './styles.css';

export const Button = ({ children, ...props }: IButtonProps) => {
  return (
    <div className={cn(styles.wrapper, props.theme && styles[props.theme], props.fullWidth && styles['full-with'])}>
      <ButtonUi {...props}>{children}</ButtonUi>
    </div>
  );
};
